import { PaginaCrud } from '../components/PaginaCrud'
import type { Almacen } from '../types'

export default function Almacenes() {
  return (
    <PaginaCrud<Almacen>
      titulo="Almacenes"
      recurso="almacenes"
      llave="id"
      columnas={[
        { campo: 'codigo', titulo: 'Codigo' },
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'direccion', titulo: 'Direccion', render: (a) => a.direccion || '-' },
        { campo: 'activo', titulo: 'Activo', render: (a) => (a.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'codigo', etiqueta: 'Codigo', tipo: 'texto', requerido: true },
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'direccion', etiqueta: 'Direccion', tipo: 'textarea' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
